// Lib
import { createSelector } from 'reselect';
import { getUsers } from '../../../../../user/usersSelector';
import { getIsModalOpen } from '../../../../../components/modal/activeModalSelector';
import { activePopupSelector } from '../../../../../components/popupPanel/popupOpenSelector';
import { getHasPushBeenPermanentlyDismissed } from './pushSuggestionService';
import {
    arePushNotificationsAlreadyPermitted,
    arePushNotificationsDenied,
    arePushNotificationsSupported,
} from '../../../../../notifications/push/pushNotificationsManager';
import {
    getShowOneTrustBanner,
    isOneTrustError,
    isOneTrustInitialised,
} from '../../../../../app/oneTrust/oneTrustSelectors';
import { getIsFeatureEnabledForCurrentUser } from '../../../../../element/feature/elementFeatureSelector';
import { ExperimentId } from '../../../../../../common/experiments/experimentsConstants';

/**
 * Whether the current user should see the push notifications suggestion popup at all.
 * It is being replaced by an Amplitude guide, so the flag lets us switch it off without a deploy.
 */
const getIsPushSuggestionEnabledForCurrentUser = getIsFeatureEnabledForCurrentUser(
    ExperimentId.pushNotificationsSuggestion,
);

export const getPushAlreadySuggestedThisSession = (state) =>
    state.getIn(['app', 'popup', 'pushSuggestion', 'alreadySuggestedThisSession']);

export const getShouldShowSuggestionsPopup = createSelector(
    getIsPushSuggestionEnabledForCurrentUser,
    getUsers,
    activePopupSelector,
    getIsModalOpen,
    getPushAlreadySuggestedThisSession,
    isOneTrustInitialised,
    isOneTrustError,
    getShowOneTrustBanner,
    (
        isPushSuggestionEnabled,
        users,
        activePopup,
        isActiveModal,
        pushAlreadySuggested,
        isOneTrustInitialised,
        isOneTrustError,
        showOneTrustBanner,
    ) => {
        const isConnectedToOtherUsers = (users && users.size > 1) || false;

        return (
            isPushSuggestionEnabled &&
            !pushAlreadySuggested &&
            !isActiveModal &&
            (!activePopup || activePopup.size === 0) &&
            isConnectedToOtherUsers &&
            arePushNotificationsSupported() &&
            !arePushNotificationsAlreadyPermitted() &&
            !arePushNotificationsDenied() &&
            !getHasPushBeenPermanentlyDismissed() &&
            (isOneTrustInitialised || isOneTrustError) &&
            !showOneTrustBanner
        );
    },
);
